import styled from 'styled-components/macro';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Code = styled.div`
  width: 50px;
  height: 55px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid rgba(17,32,43,0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CodeInput = styled.input`
  width: 50px;
  height: 55px;
  font-size: 30px;
  border-radius: 10px;
  font-family: Squad-Bold, Squad;
  font-weight: bold; color: #11202B;
  border: unset;
  text-align: center;
  padding: 0!important;
`;
